import GLOBAL_VAR from '~/utils/global'

export default {
  // 普通用户
  [GLOBAL_VAR.ROLE_0]: [
    {
      index: '/paper-submit',
      icon: 'icontijiaogaojian',
      title: 'tjgj'
    },
    {
      index: '/my-paper',
      icon: 'icongaojian',
      title: 'wdgj'
    },
    {
      index: '/certificate',
      icon: 'iconzhengming',
      title: 'bjzm'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/layout/sidebar/sidebar.js